/* Search suggestions shared by the header and the search hero.
   Uses Shopify /search/suggest.json. Create one per results container. */
window.spdSuggest = function (results) {
  var debounceTimer = null;
  var activeController = null;
  // One hidden status line per results container. The panel itself is not live, it would read every card.
  var status = results.parentNode ? results.parentNode.querySelector('[data-spd-suggest-status]') : null;
  if (!status && results.parentNode) {
    status = document.createElement('div');
    status.setAttribute('role', 'status');
    status.setAttribute('data-spd-suggest-status', '');
    status.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)';
    results.parentNode.insertBefore(status, results.nextSibling);
  }
  function announce(text) {
    if (status) status.textContent = text;
  }
      function escapeHtml(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }

      function getProductUrl(product) {
        return product.url || (product.handle ? '/products/' + product.handle : '#');
      }

      function getProductImage(product) {
        if (product.image) return product.image;
        if (product.featured_image && product.featured_image.url) return product.featured_image.url;
        if (product.featured_image) return product.featured_image;
        return '';
      }

      function getProductPrice(product) {
        if (product.price) return product.price;
        if (product.price_min) return product.price_min;
        if (product.variants && product.variants.length && product.variants[0].price) return product.variants[0].price;
        return '';
      }

      function getProductVendor(product) {
        if (product.vendor) return product.vendor;
        if (product.product_type) return product.product_type;
        return '';
      }

      // Same rules as the search form: quote capacities and synonyms, and send one
      // capacity as the Capacity filter so a 14tb search lists 14TB drives only.
      function capacityOf(query) {
        return window.spdSearchCapacity ? window.spdSearchCapacity(query) : null;
      }
      function searchHref(query, withCapacity) {
        var sent = window.spdSearchRewrite ? window.spdSearchRewrite(query) : query;
        var cap = withCapacity === false ? null : capacityOf(query);
        var kind = window.spdSearchType ? window.spdSearchType(query) : null;
        var pid = window.spdSearchPid ? window.spdSearchPid(query) : null;
        return '/search?q=' + encodeURIComponent(sent) + '&type=product&filter.p.m.filters.listed=1&filter.v.availability=1&stock=first' +
          (cap ? '&filter.p.m.filters.capacity=' + encodeURIComponent(cap) : '') +
          (kind ? '&filter.p.m.filters.device_type=' + encodeURIComponent(kind) : '') +
          (pid && pid.condition ? '&filter.p.m.filters.condition=' + encodeURIComponent(pid.condition) : '');
      }
      function capacityPattern(cap) {
        var m = /^(\d+(?:\.\d+)?)(TB|GB)$/i.exec(cap || '');
        return m ? new RegExp('(^|[^\\d.])' + m[1].replace('.', '\\.') + '\\s?' + m[2] + '(?![\\w/])', 'i') : null;
      }

      function renderResults(data, query) {
        var resources = data && data.resources && data.resources.results ? data.resources.results : {};
        var products = resources.products || [];
        // Shopify's search adds synonyms and fuzzy matches, so nonsense gets its nearest products.
        // Keep suggestions that carry a query word somewhere.
        var words = String(query || '').toLowerCase().replace(/["'()\-\/,:]/g, ' ').split(/\s+/).filter(function (w) { return w.length > 1 && w !== 'or' && w !== 'and'; });
        if (words.length && !(data && data.typed)) {
          var closest = products;
          products = products.filter(function (p) {
            var hay = ' ' + [p.title, p.vendor, p.type, (p.tags || []).join(' '), (p.variants || []).map(function (v) { return v.sku || ''; }).join(' ')].join(' ').toLowerCase().replace(/[\-\/(),:]/g, ' ');
            // Dell part numbers are listed as 0HNHWC but often typed as HNHWC, or HNH while typing.
            return words.some(function (w) { return hay.indexOf(' ' + w) !== -1 || hay.indexOf(' 0' + w) !== -1; });
          });
          // Two characters in, show Shopify's closest matches rather than nothing.
          if (!products.length && String(query || '').trim().length === 2) products = closest;
        }
        // A part id with a condition code (PN-MR) lists that condition's product only.
        var pid = window.spdSearchPid ? window.spdSearchPid(query) : null;
        if (pid && pid.condition) {
          var coded = products.filter(function (p) {
            return (p.variants || []).some(function (v) { return new RegExp('_' + pid.code + '$', 'i').test(v.sku || ''); });
          });
          if (coded.length) products = coded;
        }
        var capRe = capacityPattern(capacityOf(query));
        var withCapacity = false;
        if (capRe) {
          var sized = products.filter(function (p) { return capRe.test(p.title || ''); });
          if (sized.length) { products = sized; withCapacity = true; }
        }
        var collections = resources.collections || [];
        var queries = resources.queries || [];

        var sideHtml = '';
        if (queries.length) {
          sideHtml += '<div class="hdr-srch-results__heading">Suggestions</div>';
          sideHtml += '<ul class="hdr-srch-results__list hdr-srch-results__list--queries">';
          queries.slice(0, 5).forEach(function(item) {
            var text = item.text || '';
            var href = searchHref(text);
            sideHtml += '<li><a class="hdr-srch-results__link" href="' + escapeHtml(href) + '">' + escapeHtml(text) + '</a></li>';
          });
          sideHtml += '</ul>';
        }
        // Categories only when a collection matched; the typed words are not a category.
        if (collections.length) {
          sideHtml += '<div class="hdr-srch-results__heading">Categories</div>';
          sideHtml += '<ul class="hdr-srch-results__list">';
          collections.slice(0, 5).forEach(function(collection) {
            sideHtml += '<li><a class="hdr-srch-results__link" href="' + escapeHtml(collection.url) + '">' + escapeHtml(collection.title) + '</a></li>';
          });
          sideHtml += '</ul>';
        }

        var productsHtml = '<div class="hdr-srch-results__heading">Products</div>';

        if (products.length) {
          productsHtml += '<ul class="hdr-srch-results__products">';
          products.slice(0, 10).forEach(function(product) {
            var image = getProductImage(product);
            var price = getProductPrice(product);
            var vendor = getProductVendor(product);

            productsHtml += '<li>';
            productsHtml += '<a class="hdr-srch-product" href="' + escapeHtml(getProductUrl(product)) + '">';
            productsHtml += image ? '<img class="hdr-srch-product__image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '">' : '<span class="hdr-srch-product__image"></span>';
            productsHtml += '<span>';
            productsHtml += '<p class="hdr-srch-product__title">' + escapeHtml(product.title) + '</p>';
            if (vendor) productsHtml += '<p class="hdr-srch-product__vendor">' + escapeHtml(vendor) + '</p>';
            if (price) productsHtml += '<span class="hdr-srch-product__price">' + escapeHtml(price) + '</span>';
            productsHtml += '</span>';
            productsHtml += '</a>';
            productsHtml += '</li>';
          });
          productsHtml += '</ul>';
        } else {
          productsHtml += '<div class="hdr-srch-results__empty">No products found.</div>';
          productsHtml += '<a class="hdr-srch-results__procure" href="/pages/enterprise-hardware-procurement">Can\u2019t find what you\u2019re looking for? We can procure it <span>\u2192</span></a>';
        }

        var sent = window.spdSearchRewrite ? window.spdSearchRewrite(query) : query;
        if (sent !== query) { try { sessionStorage.setItem('spd_oq:' + sent, query); } catch (e) {} }
        var viewAll = searchHref(query, withCapacity);

        results.hidden = false;
        results.innerHTML =
          '<div class="hdr-srch-results__inner">' +
            '<div class="hdr-srch-results__side">' + sideHtml + '</div>' +
            '<div class="hdr-srch-results__main">' + productsHtml + '</div>' +
          '</div>' +
          '<a class="hdr-srch-results__view-all" href="' + viewAll + '">View all results <span>→</span></a>';

        var shown = Math.min(products.length, 10);
        var side = Math.min(queries.length, 5) + Math.min(collections.length, 5);
        announce(shown
          ? shown + (shown === 1 ? ' product' : ' products') + (side ? ' and ' + side + (side === 1 ? ' suggestion' : ' suggestions') : '') + ', press Tab to review'
          : 'No products found');
      }

      function normalizeQueryTerms(query) {
        return String(query || '')
          .toLowerCase()
          .replace(/[^\w.\-+]+/g, ' ')
          .split(/\s+/)
          .filter(function(term) {
            return term && term.length >= 2;
          })
          .slice(0, 5);
      }

      function mergeSuggestResults(responses) {
        var merged = {
          resources: {
            results: {
              products: [],
              collections: [],
              queries: []
            }
          }
        };

        var seenProducts = {};
        var seenCollections = {};

        responses.forEach(function(data) {
          var resources = data && data.resources && data.resources.results ? data.resources.results : {};
          var products = resources.products || [];
          var collections = resources.collections || [];
          var queries = resources.queries || [];

          if (queries.length && !merged.resources.results.queries.length) {
            merged.resources.results.queries = queries.slice(0, 5);
          }

          products.forEach(function(product) {
            var key = product.id || product.handle || product.url || product.title;
            if (!key || seenProducts[key]) return;
            seenProducts[key] = true;
            merged.resources.results.products.push(product);
          });

          collections.forEach(function(collection) {
            var key = collection.id || collection.handle || collection.url || collection.title;
            if (!key || seenCollections[key]) return;
            seenCollections[key] = true;
            merged.resources.results.collections.push(collection);
          });
        });

        return merged;
      }

      function runSearch(query) {
        if (!query || query.length < 2) {
          results.hidden = true;
          results.innerHTML = '';
          announce('');
          return;
        }

        if (activeController) activeController.abort();
        activeController = window.AbortController ? new AbortController() : null;

        results.hidden = false;
        results.innerHTML = '<div class="hdr-srch-results__loading">Searching...</div>';

        var searchFields = [
          'title',
          'product_type',
          'vendor',
          'tag',
          'variants.title',
          'variants.sku',
          'variants.barcode'
        ].join(',');

        function buildSuggestUrl(searchTerm, includeCollections) {
          return '/search/suggest.json?q=' + encodeURIComponent(searchTerm) +
            '&resources[type]=' + (includeCollections ? 'product,collection,query' : 'product') +
            '&resources[limit]=10' +
            '&resources[limit_scope]=each' +
            '&resources[options][unavailable_products]=hide' +
            '&resources[options][fields]=' + encodeURIComponent(searchFields);
        }

        function fetchSuggest(url) {
          return fetch(url, {
            method: 'GET',
            signal: activeController ? activeController.signal : undefined,
            headers: { 'Accept': 'application/json' }
          }).then(function(response) {
            if (!response.ok) throw new Error('Search request failed');
            return response.json();
          });
        }

        var terms = normalizeQueryTerms(query);
        var queries = [query];

        terms.forEach(function(term) {
          if (queries.indexOf(term) === -1) queries.push(term);
        });

        var requests = queries.map(function(searchTerm, index) {
          return fetchSuggest(buildSuggestUrl(searchTerm, index === 0))
            .catch(function(error) {
              if (error.name === 'AbortError') throw error;
              return null;
            });
        });

        var kind = window.spdSearchType ? window.spdSearchType(query) : null;
        var typedRequest = kind ? fetch('/search?q=' + encodeURIComponent(query) + '&type=product&filter.p.m.filters.device_type=' + encodeURIComponent(kind) + '&filter.p.m.filters.listed=1&filter.v.availability=1&stock=first', {
          signal: activeController ? activeController.signal : undefined
        }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return Array.prototype.slice.call(doc.querySelectorAll('.spd-card'), 0, 10).map(function (card) {
            var media = card.querySelector('.spd-card__media');
            var img = card.querySelector('.spd-card__media img');
            return {
              title: (card.querySelector('.spd-card__title') || {}).textContent || '',
              url: media ? media.getAttribute('href') : '#',
              image: img ? (img.getAttribute('src') || (img.getAttribute('srcset') || '').split(' ')[0]) : '',
              price: (card.querySelector('.spd-card__price') || {}).textContent || '',
              vendor: kind,
              tags: ['type:' + kind],
              variants: []
            };
          });
        }).catch(function (error) { if (error.name === 'AbortError') throw error; return []; }) : Promise.resolve([]);

        Promise.all([Promise.all(requests), typedRequest])
          .then(function(both) {
            var responses = both[0], typed = both[1];
            var cleanResponses = responses.filter(Boolean);
            var merged = mergeSuggestResults(cleanResponses);

            if (typed.length) {
              var res = merged && merged.resources && merged.resources.results ? merged.resources.results : {};
              return { typed: true, resources: { results: { products: typed, collections: res.collections || [], queries: res.queries || [] } } };
            }

            var products = merged &&
              merged.resources &&
              merged.resources.results &&
              merged.resources.results.products
                ? merged.resources.results.products
                : [];

            if (products.length) return merged;

            return fetchSuggest(buildSuggestUrl(query, false));
          })
          .then(function(data) {
            renderResults(data, query);
          })
          .catch(function(error) {
            if (error.name === 'AbortError') return;
            results.hidden = false;
            results.innerHTML =
              '<div class="hdr-srch-results__empty">Instant results are unavailable. Press Enter to search.</div>';
            announce('Instant results are unavailable. Press Enter to search.');
          });
      }

  function queue(query) {
    query = String(query || '').trim();
    clearTimeout(debounceTimer);
    if (query.length < 2) { clear(); return; }
    debounceTimer = setTimeout(function () { runSearch(query); }, 220);
  }
  function clear() {
    clearTimeout(debounceTimer);
    if (activeController) activeController.abort();
    results.hidden = true;
    results.innerHTML = '';
    announce('');
  }
  return { queue: queue, run: runSearch, clear: clear };
};
